import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { BiDotsHorizontal } from 'react-icons/bi';
import ReactLoading from 'react-loading';

// Utility imports
import AuthService from '../../../../services/auth';
import { useGet } from '../../../../reducers/useGet';
import { useGetWithRefresh } from '../../../../reducers/useGetWithRefresh';
import downloadCSV from '../../../../scripts/export-script';

// Component imports
import SelectDataButton from '../../date-selector';
import ErrorMessage from '../../messages-panel/error-message';
import NoDataAvailableMessage from '../../messages-panel/no-data-available-message';
import ExportButton from '../../../data-table-custom/export-button';
import { BarChart1Element } from '../../charts';

// Styles
import './fan-energy-data-animal-style.css';
import { Hidrometer } from './hidrometer';
import { AccumulatedValue } from './accumulated-value';
import { isNumber } from 'lodash';
import { hidrometer } from '../../../../sensors-type';

import { FaCircle } from 'react-icons/fa';
import { RiAlertFill } from 'react-icons/ri';

// Constantes
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm';
const STATUS_COLORS = {
	ONLINE_NORMAL: 'green',
	ONLINE_ALERT: 'red',
	OFFLINE: 'gray',
};

const consumoDemo = [
  { dia: '2024-11-30 00:00:00.000000', kwh: 169.8625 },
  { dia: '2024-12-01 00:00:00.000000', kwh: 163.7875 },
  { dia: '2024-12-02 00:00:00.000000', kwh: 167.04052 },
  { dia: '2024-12-03 00:00:00.000000', kwh: 170.41552 },
  { dia: '2024-12-04 00:00:00.000000', kwh: 175.14052 },
  { dia: '2024-12-05 00:00:00.000000', kwh: 171.76552 },
  { dia: '2024-12-06 00:00:00.000000', kwh: 165.01552 },
  { dia: '2024-12-07 00:00:00.000000', kwh: 173.11552 },
  { dia: '2024-12-08 00:00:00.000000', kwh: 166.94 },
  { dia: '2024-12-09 00:00:00.000000', kwh: 176.7533 },
  { dia: '2024-12-10 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-11 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-12 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-13 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-14 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-15 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-16 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-17 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-18 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-19 00:00:00.000000', kwh: 112.42 },
  { dia: '2024-12-20 00:00:00.000000', kwh: 117.82455 },
  { dia: '2024-12-21 00:00:00.000000', kwh: 130.2 },
  { dia: '2024-12-22 00:00:00.000000', kwh: 39 },
  { dia: '2024-12-23 00:00:00.000000', kwh: 134.3375 },
  { dia: '2024-12-24 00:00:00.000000', kwh: 113.035 },
  { dia: '2024-12-25 00:00:00.000000', kwh: 69 },
  { dia: '2024-12-26 00:00:00.000000', kwh: 116.643375 },
  { dia: '2024-12-27 00:00:00.000000', kwh: 122.7825 },
  { dia: '2024-12-28 00:00:00.000000', kwh: 0 },
  { dia: '2024-12-29 00:00:00.000000', kwh: 114.1155 },
  { dia: '2024-12-30 00:00:00.000000', kwh: 118.449 },
  { dia: '2024-12-31 00:00:00.000000', kwh: 0 },
  { dia: '2025-01-01 00:00:00.000000', kwh: 158.9625 },
  { dia: '2025-01-02 00:00:00.000000', kwh: 156.2625 },
  { dia: '2025-01-03 00:00:00.000000', kwh: 165.375 },
  { dia: '2025-01-04 00:00:00.000000', kwh: 161.325 },
  { dia: '2025-01-05 00:00:00.000000', kwh: 157.95 },
  { dia: '2025-01-06 00:00:00.000000', kwh: 162.3375 },
  { dia: '2025-01-07 00:00:00.000000', kwh: 167.4 },
  { dia: '2025-01-08 00:00:00.000000', kwh: 158.625 },
  { dia: '2025-01-09 00:00:00.000000', kwh: 154.9125 },
  { dia: '2025-01-10 00:00:00.000000', kwh: 164.3625 },
  { dia: '2025-01-11 00:00:00.000000', kwh: 168.4125 },
  { dia: '2025-01-12 00:00:00.000000', kwh: 164.7 },
  { dia: '2025-01-13 00:00:00.000000', kwh: 157.275 },
  { dia: '2025-01-14 00:00:00.000000', kwh: 160.65 },
  { dia: '2025-01-15 00:00:00.000000', kwh: 166.05 },
  { dia: '2025-01-16 00:00:00.000000', kwh: 162 },
  { dia: '2025-01-17 00:00:00.000000', kwh: 155.25 },
  { dia: '2025-01-18 00:00:00.000000', kwh: 159.975 },
  { dia: '2025-01-19 00:00:00.000000', kwh: 167.7375 },
  { dia: '2025-01-20 00:00:00.000000', kwh: 163.35 },
  { dia: '2025-01-21 00:00:00.000000', kwh: 157.95 },
  { dia: '2025-01-22 00:00:00.000000', kwh: 158.9625 },
  { dia: '2025-01-23 00:00:00.000000', kwh: 164.3625 },
  { dia: '2025-01-24 00:00:00.000000', kwh: 168.75 },
  { dia: '2025-01-25 00:00:00.000000', kwh: 161.325 },
  { dia: '2025-01-26 00:00:00.000000', kwh: 156.2625 },
  { dia: '2025-01-27 00:00:00.000000', kwh: 162.3375 },
  { dia: '2025-01-28 00:00:00.000000', kwh: 0 },
  { dia: '2025-01-29 00:00:00.000000', kwh: 0 },
  { dia: '2025-01-30 00:00:00.000000', kwh: 0 },
  { dia: '2025-01-31 00:00:00.000000', kwh: 0 },
  { dia: '2025-02-01 00:00:00.000000', kwh: 161.325 },
  { dia: '2025-02-02 00:00:00.000000', kwh: 157.95 },
  { dia: '2025-02-03 00:00:00.000000', kwh: 163.35 },
  { dia: '2025-02-04 00:00:00.000000', kwh: 166.05 },
  { dia: '2025-02-05 00:00:00.000000', kwh: 162 },
  { dia: '2025-02-06 00:00:00.000000', kwh: 155.25 },
  { dia: '2025-02-07 00:00:00.000000', kwh: 164.3625 },
  { dia: '2025-02-08 00:00:00.000000', kwh: 167.7375 },
  { dia: '2025-02-09 00:00:00.000000', kwh: 158.9625 },
  { dia: '2025-02-10 00:00:00.000000', kwh: 156.2625 },
  { dia: '2025-02-11 00:00:00.000000', kwh: 164.7 },
  { dia: '2025-02-12 00:00:00.000000', kwh: 168.4125 },
  { dia: '2025-02-13 00:00:00.000000', kwh: 162.3375 },
  { dia: '2025-02-14 00:00:00.000000', kwh: 157.275 },
  { dia: '2025-02-15 00:00:00.000000', kwh: 160.65 },
  { dia: '2025-02-16 00:00:00.000000', kwh: 165.375 },
  { dia: '2025-02-17 00:00:00.000000', kwh: 162 },
  { dia: '2025-02-18 00:00:00.000000', kwh: 155.25 },
  { dia: '2025-02-19 00:00:00.000000', kwh: 163.35 },
  { dia: '2025-02-20 00:00:00.000000', kwh: 167.4 },
  { dia: '2025-02-21 00:00:00.000000', kwh: 158.9625 },
  { dia: '2025-02-22 00:00:00.000000', kwh: 154.9125 },
  { dia: '2025-02-23 00:00:00.000000', kwh: 0 },
  { dia: '2025-02-24 00:00:00.000000', kwh: 0 },
  { dia: '2025-02-25 00:00:00.000000', kwh: 0 },
  { dia: '2025-02-26 00:00:00.000000', kwh: 0 },
  { dia: '2025-02-27 00:00:00.000000', kwh: 0 },
  { dia: '2025-02-28 00:00:00.000000', kwh: 159.975 },
  { dia: '2025-03-01 00:00:00.000000', kwh: 143.1 },
  { dia: '2025-03-02 00:00:00.000000', kwh: 136.6875 },
  { dia: '2025-03-03 00:00:00.000000', kwh: 131.625 },
  { dia: '2025-03-04 00:00:00.000000', kwh: 127.2375 },
  { dia: '2025-03-05 00:00:00.000000', kwh: 122.5125 },
  { dia: '2025-03-06 00:00:00.000000', kwh: 113.7375 },
  { dia: '2025-03-07 00:00:00.000000', kwh: 102.2625 },
  { dia: '2025-03-08 00:00:00.000000', kwh: 0 },
  { dia: '2025-03-09 00:00:00.000000', kwh: 116.1 },
  { dia: '2025-03-10 00:00:00.000000', kwh: 124.5375 },
  { dia: '2025-03-11 00:00:00.000000', kwh: 129.9375 },
  { dia: '2025-03-12 00:00:00.000000', kwh: 128.25 },
  { dia: '2025-03-13 00:00:00.000000', kwh: 118.8 },
  { dia: '2025-03-14 00:00:00.000000', kwh: 0 },
  { dia: '2025-03-15 00:00:00.000000', kwh: 123.1875 },
  { dia: '2025-03-16 00:00:00.000000', kwh: 132.975 },
  { dia: '2025-03-17 00:00:00.000000', kwh: 127.2375 },
  { dia: '2025-03-18 00:00:00.000000', kwh: 120.4875 },
  { dia: '2025-03-19 00:00:00.000000', kwh: 109.6875 },
  { dia: '2025-03-20 00:00:00.000000', kwh: 0 },
  { dia: '2025-03-21 00:00:00.000000', kwh: 115.0875 },
  { dia: '2025-03-22 00:00:00.000000', kwh: 125.8875 },
  { dia: '2025-03-23 00:00:00.000000', kwh: 129.6 },
  { dia: '2025-03-24 00:00:00.000000', kwh: 120.15 },
  { dia: '2025-03-25 00:00:00.000000', kwh: 104.625 },
  { dia: '2025-03-26 00:00:00.000000', kwh: 0 },
  { dia: '2025-03-27 00:00:00.000000', kwh: 113.7375 },
  { dia: '2025-03-28 00:00:00.000000', kwh: 122.175 },
  { dia: '2025-03-29 00:00:00.000000', kwh: 132.3 },
  { dia: '2025-03-30 00:00:00.000000', kwh: 127.2375 },
  { dia: '2025-03-31 00:00:00.000000', kwh: 118.125 },
  { dia: '2025-04-01 00:00:00.000000', kwh: 114.75 },
  { dia: '2025-04-02 00:00:00.000000', kwh: 106.65 },
  { dia: '2025-04-03 00:00:00.000000', kwh: 0 },
  { dia: '2025-04-04 00:00:00.000000', kwh: 112.05 },
  { dia: '2025-04-05 00:00:00.000000', kwh: 120.4875 },
  { dia: '2025-04-06 00:00:00.000000', kwh: 125.2125 },
  { dia: '2025-04-07 00:00:00.000000', kwh: 116.775 },
  { dia: '2025-04-08 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-04-09 00:00:00.000000', kwh: 0 },
  { dia: '2025-04-10 00:00:00.000000', kwh: 115.0875 },
  { dia: '2025-04-11 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-04-12 00:00:00.000000', kwh: 102.2625 },
  { dia: '2025-04-13 00:00:00.000000', kwh: 0 },
  { dia: '2025-04-14 00:00:00.000000', kwh: 118.8 },
  { dia: '2025-04-15 00:00:00.000000', kwh: 122.175 },
  { dia: '2025-04-16 00:00:00.000000', kwh: 116.1 },
  { dia: '2025-04-17 00:00:00.000000', kwh: 108.3375 },
  { dia: '2025-04-18 00:00:00.000000', kwh: 0 },
  { dia: '2025-04-19 00:00:00.000000', kwh: 116.775 },
  { dia: '2025-04-20 00:00:00.000000', kwh: 124.5375 },
  { dia: '2025-04-21 00:00:00.000000', kwh: 119.475 },
  { dia: '2025-04-22 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-04-23 00:00:00.000000', kwh: 101.5875 },
  { dia: '2025-04-24 00:00:00.000000', kwh: 0 },
  { dia: '2025-04-25 00:00:00.000000', kwh: 114.75 },
  { dia: '2025-04-26 00:00:00.000000', kwh: 122.85 },
  { dia: '2025-04-27 00:00:00.000000', kwh: 120.4875 },
  { dia: '2025-04-28 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-04-29 00:00:00.000000', kwh: 104.625 },
  { dia: '2025-04-30 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-01 00:00:00.000000', kwh: 108.3375 },
  { dia: '2025-05-02 00:00:00.000000', kwh: 102.2625 },
  { dia: '2025-05-03 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-04 00:00:00.000000', kwh: 112.05 },
  { dia: '2025-05-05 00:00:00.000000', kwh: 116.775 },
  { dia: '2025-05-06 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-05-07 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-08 00:00:00.000000', kwh: 113.7375 },
  { dia: '2025-05-09 00:00:00.000000', kwh: 118.125 },
  { dia: '2025-05-10 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-05-11 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-05-12 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-13 00:00:00.000000', kwh: 114.75 },
  { dia: '2025-05-14 00:00:00.000000', kwh: 116.1 },
  { dia: '2025-05-15 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-05-16 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-17 00:00:00.000000', kwh: 113.7375 },
  { dia: '2025-05-18 00:00:00.000000', kwh: 117.45 },
  { dia: '2025-05-19 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-05-20 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-21 00:00:00.000000', kwh: 112.05 },
  { dia: '2025-05-22 00:00:00.000000', kwh: 115.0875 },
  { dia: '2025-05-23 00:00:00.000000', kwh: 104.625 },
  { dia: '2025-05-24 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-25 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-05-26 00:00:00.000000', kwh: 116.775 },
  { dia: '2025-05-27 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-05-28 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-05-29 00:00:00.000000', kwh: 0 },
  { dia: '2025-05-30 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-05-31 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-06-01 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-02 00:00:00.000000', kwh: 106.65 },
  { dia: '2025-06-03 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-06-04 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-05 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-06-06 00:00:00.000000', kwh: 112.05 },
  { dia: '2025-06-07 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-08 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-06-09 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-06-10 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-06-11 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-12 00:00:00.000000', kwh: 108.3375 },
  { dia: '2025-06-13 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-06-14 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-15 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-06-16 00:00:00.000000', kwh: 114.75 },
  { dia: '2025-06-17 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-18 00:00:00.000000', kwh: 106.65 },
  { dia: '2025-06-19 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-06-20 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-21 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-06-22 00:00:00.000000', kwh: 108.3375 },
  { dia: '2025-06-23 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-06-24 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-25 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-06-26 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-06-27 00:00:00.000000', kwh: 0 },
  { dia: '2025-06-28 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-06-29 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-06-30 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-01 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-07-02 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-03 00:00:00.000000', kwh: 112.05 },
  { dia: '2025-07-04 00:00:00.000000', kwh: 115.0875 },
  { dia: '2025-07-05 00:00:00.000000', kwh: 104.625 },
  { dia: '2025-07-06 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-07 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-07-08 00:00:00.000000', kwh: 116.775 },
  { dia: '2025-07-09 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-07-10 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-07-11 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-12 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-07-13 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-07-14 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-15 00:00:00.000000', kwh: 106.65 },
  { dia: '2025-07-16 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-07-17 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-18 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-07-19 00:00:00.000000', kwh: 112.05 },
  { dia: '2025-07-20 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-21 00:00:00.000000', kwh: 105.3 },
  { dia: '2025-07-22 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-07-23 00:00:00.000000', kwh: 113.4 },
  { dia: '2025-07-24 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-25 00:00:00.000000', kwh: 108.3375 },
  { dia: '2025-07-26 00:00:00.000000', kwh: 103.275 },
  { dia: '2025-07-27 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-28 00:00:00.000000', kwh: 109.0125 },
  { dia: '2025-07-29 00:00:00.000000', kwh: 114.75 },
  { dia: '2025-07-30 00:00:00.000000', kwh: 0 },
  { dia: '2025-07-31 00:00:00.000000', kwh: 106.65 },
  { dia: '2025-08-01 00:00:00.000000', kwh: 110.7 },
  { dia: '2025-08-02 00:00:00.000000', kwh: 0 },
  { dia: '2025-08-03 00:00:00.000000', kwh: 105.3 },
];

const chartSource = consumoDemo.map(item => ({
  timestamp: item.dia , // evita timezone bug
  value: item.kwh,
}));

export default function FanEnergyData() {
  const [showChart, setShowChart] = useState(false);

  const ultimo = consumoDemo.at(-1);
  const valor = ultimo.kwh;
  const ultimaData = ultimo.dia;
  const dataFormatada = new Date(ultimaData).toLocaleDateString('pt-BR');

  // Estados para os dados do gráfico diário
  const [dailyChartData, setDailyChartData] = useState([]);
  const [dailyChartPeriod1, setDailyChartPeriod1] = useState(null);
  const [dailyChartPeriod2, setDailyChartPeriod2] = useState(null);

  // Componente de exportação
  const Export = ({ onExport }) => <ExportButton onExport={onExport} chartPanel={true} />;

  // Transformar dados uma única vez
  const dailyChartData1 = useMemo(() => 
    consumoDemo.map(item => ({
      timestamp: new Date(item.dia),
      value: item.kwh,
    })),
    [] // consumoDemo é constante, mas se vier de props/API, adicione aqui
  );

  // useEffect inicial - define os últimos 7 dias
  useEffect(() => {
    if (dailyChartData1.length < 7) return;

    const last7 = dailyChartData1.slice(-7);
  
    setDailyChartData(last7);
  
    // Passa o timestamp (número) ao invés do objeto Date
    // Moment lida melhor com timestamps
    const startDate = new Date(last7[0].timestamp);
    const endDate = new Date(last7.at(-1).timestamp);
  
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
  
    // Converte para timestamp antes de setar
    setDailyChartPeriod1(startDate.getTime());
    //setDailyChartPeriod2(endDate.getTime());
  }, [dailyChartData1]);

    // useEffect para atualizar dados quando as datas mudam
  useEffect(() => {
    if (!dailyChartPeriod1 && !dailyChartPeriod2) return;

    const filteredData = dailyChartData1.filter(item => {
      const itemDate = new Date(item.timestamp);
      itemDate.setHours(0, 0, 0, 0);
      const itemTime = itemDate.getTime();

      if (dailyChartPeriod1 && !dailyChartPeriod2) {
        // dailyChartPeriod1 pode ser Date ou number agora
        const startTime = typeof dailyChartPeriod1 === 'number' 
          ? dailyChartPeriod1 
          : new Date(dailyChartPeriod1).getTime();
        return itemTime >= startTime;
      } 

      if (!dailyChartPeriod1 && dailyChartPeriod2) {
        const endTime = typeof dailyChartPeriod2 === 'number'
          ? dailyChartPeriod2
          : new Date(dailyChartPeriod2).getTime();
        return itemTime <= endTime;
      }

      const startTime = typeof dailyChartPeriod1 === 'number'
        ? dailyChartPeriod1
        : new Date(dailyChartPeriod1).getTime();
      const endTime = typeof dailyChartPeriod2 === 'number'
        ? dailyChartPeriod2
        : new Date(dailyChartPeriod2).getTime();
    
      return itemTime >= startTime && itemTime <= endTime;
    });

    setDailyChartData(filteredData);
  }, [dailyChartPeriod1, dailyChartPeriod2, dailyChartData1]);

  return (
    <div className="little-panel-container">
      <div className="panel-title-container">
        <em className="panel-title">Consumo de Energia</em>
      </div>

      <div style={{ margin: '10px' }}>
        {/* Último dado */}
        <div className="last-data-container">
          <div className="last-data-content-container">
            <div className="container-hidrometro">
              <div className="circle-hidrometro">
                <div className="inner-circle-hidrometro">
                  <p>Consumo</p>
                  <p className="value-hidrometro">
                    {valor} kWh
                  </p>
                  <p>{dataFormatada}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ paddingBottom: '10px' }}>
          {/* Botão de detalhes */}
          <button className="more-details-button" onClick={() => setShowChart(!showChart)}>
            + Detalhes
          </button>
          
          {/* Seção de gráfico (expansível) */}
          {showChart && (
            <div>
              <div
                style={{
                  width: '100%',
                  height: '1.5px',
                  backgroundColor: 'black',
                  borderRadius: '20px',
                  margin: '10px 0px 5px 0px',
                }}
              />
              <div className="panel-items">
                <BiDotsHorizontal />
                <span className="panel-items-title">Gráfico Diário do Consumo</span>
              </div>
              
              <SelectDataButton
                periodo1={dailyChartPeriod1}
                setPeriodo1={setDailyChartPeriod1}
                periodo2={dailyChartPeriod2}
                setPeriodo2={setDailyChartPeriod2}
                hourlyData={false}
              />
              
              {dailyChartData.length > 0 ? (
                <BarChart1Element
                  data={dailyChartData}
                  unit={'kwh'}
                  color={'#187BCD'}
                  fileName={'grafico-consumo'}
                />
              ) : (
                <NoDataAvailableMessage />
              )}
              
              {dailyChartData.length > 0 && (
                <div className="panel-items">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div>
                      <BiDotsHorizontal />
                      <span className="panel-items-title">Exportar dados do Gráfico</span>
                    </div>
                    <Export
                      onExport={() => downloadCSV(dailyChartData, 'dados')}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
